import React from 'react';
import { cn } from './cn';

/**
 * Card — surface chính (radius 12px, border-line, shadow-xs). Token tự lật light/dark.
 * interactive=true → hover đổi viền + con trỏ pointer (theo SKILL2 interactive card).
 */
export function Card({ className, children, as: Tag = 'div', interactive = false, ...props }) {
  return (
    <Tag
      className={cn(
        'rounded-xl border border-line bg-surface shadow-xs',
        interactive && 'cursor-pointer transition-colors hover:border-line-strong',
        className
      )}
      {...props}
    >
      {children}
    </Tag>
  );
}

export function CardHeader({ className, children, ...props }) {
  return (
    <div
      className={cn('flex items-center justify-between gap-3 px-6 py-4 border-b border-line', className)}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardTitle({ className, children, as: Tag = 'h3', ...props }) {
  return (
    <Tag className={cn('text-base sm:text-lg font-semibold text-heading', className)} {...props}>
      {children}
    </Tag>
  );
}

export function CardDescription({ className, children, ...props }) {
  return (
    <p className={cn('text-sm text-muted mt-1', className)} {...props}>
      {children}
    </p>
  );
}

export function CardBody({ className, children, ...props }) {
  return (
    <div className={cn('p-6', className)} {...props}>
      {children}
    </div>
  );
}

export function CardFooter({ className, children, ...props }) {
  return (
    <div className={cn('flex items-center justify-end gap-3 px-6 py-4 border-t border-line', className)} {...props}>
      {children}
    </div>
  );
}

export default Card;
